import { AfterViewInit, Directive, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { LcsMultiSelectComponent } from '@lcs/shared/multi-select';
import { ExtensionTypes } from 'generated/graphql-types';
import { AppState } from 'src/app/app.reducer';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { ExtensionMultiSelectDataSource } from './extension-multi-select-data-source';

@Directive({
    selector: 'lcs-multi-select[ndtExtensionMultiSelect]',
    standalone: false
})
export class ExtensionMultiSelectDirective implements AfterViewInit {
   @Input() accountId: number | null;

   @Input() extensionTypesToInclude: ExtensionTypes[] = [];

   @Input() extensionTypesToExclude: ExtensionTypes[] = [];

   @Input() extensionIdsToExclude: number[] = [];

   constructor(private multiSelect: LcsMultiSelectComponent<ExtensionOption>, private store: Store<AppState>) {
      this.multiSelect.data = new ExtensionMultiSelectDataSource(this.store, []);
      this.multiSelect.displayWith = (item: ExtensionOption | null) => {
         return item ? `${item.number} - ${item.name}` : null;
      };
   }

   ngAfterViewInit(): void {
      const staticFilterOverride: string[] = [];
      staticFilterOverride.push(`IsArchived = false`);
      if (this.accountId) {
         staticFilterOverride.push(`AccountId = ${this.accountId}`);
      }

      if (this.extensionTypesToInclude.length > 0) {
         staticFilterOverride.push(`Type in (${this.extensionTypesToInclude.join(', ')})`);
      }

      if (this.extensionTypesToExclude.length > 0) {
         staticFilterOverride.push(`Type not in (${this.extensionTypesToExclude.join(', ')})`);
      }

      if (this.extensionIdsToExclude.length > 0) {
         staticFilterOverride.push(`ExtensionId not in (${this.extensionIdsToExclude.join(', ')})`);
      }

      // This is being set twice because the lcs shared component we're using for some reason only checks the validity of the selectAll button's existence once
      this.multiSelect.data = new ExtensionMultiSelectDataSource(this.store, staticFilterOverride);
   }
}
